// extracted by mini-css-extract-plugin
export default {"Base":"Status_Base__-j6KZ","Loading":"Status_Loading__Sd6bM","Ok":"Status_Ok__EE1cm"};